import type { FactoryStatus } from '@indutrust/factory-model';

/**
 * Map a {@link FactoryStatus} to a PrimeNG `p-tag` severity value for themed display.
 *
 * @param status The factory status or undefined.
 * @returns A PrimeNG severity string ('secondary' | 'warn' | 'success').
 * @example
 * const severity = getFactoryStatusSeverity('published'); // "success"
 */
export function getFactoryStatusSeverity(
  status: FactoryStatus | undefined
): 'secondary' | 'warn' | 'success' {
  switch (status) {
    case 'published':
      return 'success';
    case 'pending':
      return 'warn';
    case 'draft':
    case undefined:
    default:
      return 'secondary';
  }
}

/**
 * Map a {@link FactoryStatus} to a PrimeIcons icon name (without the `pi-` prefix).
 *
 * @param status The factory status or undefined.
 * @returns A PrimeIcons icon name (e.g., `'verified'`), suitable for `pi pi-{name}`.
 * @example
 * const icon = getFactoryStatusIcon('pending'); // "hourglass"
 */
export function getFactoryStatusIcon(status: FactoryStatus | undefined) {
  switch (status) {
    case 'draft':
      return 'file-edit';
    case 'pending':
      return 'hourglass';
    case 'published':
      return 'verified';
    case undefined:
      return 'file-edit';
    default:
      return 'file-edit';
  }
}
